<form name="form" class="page-fix-accessibility-form" #form="ngForm">
    <page-fix-form-wizard-container (dismiss)="dismiss.emit()"
                                    (close)="closeModal($event.pageFix)"
                                    [formValid]="!!form.valid && customValidation"
                                    [pageFixApplied]="!!pageFix"
                                    [pageFix]="pageFix">
        <page-fix-form-info-view [monType]="infoViewType"
                                 [monSelected]="!pageFix"
                                 [monOrder]="0">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/design/marquee.png"
                     [attr.alt]="'Marquee sample image' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>Why shouldn't I use the marquee element?</h2>
                <p translate>
                    A marquee element was previously used to show the scrolling area of the text (example: text
                    scrolling across the page from left to right), but is now considered obsolete and should be avoided.
                    Moving text is an accessibility concern as it can be hard to read for many people with visual
                    impairments or learning disabilities.
                </p>
                <h3 translate>And how are we going to fix it?</h3>
                <p translate>
                    Since marquee tags are obsolete they need to be replaced.
                    Choose a tag in the options card you wish to use on your website instead.
                </p>
            </txt-slot>
        </page-fix-form-info-view>
        <page-fix-form-marquee-options [monPageFix]="pageFix"
                                       [monPageFixId]="pageFixId"
                                       [monPageFixSelector]="pageFixSelector"
                                       [monType]="optionsViewType"
                                       [monSelected]="!!pageFix"
                                       [monOrder]="1">
        </page-fix-form-marquee-options>
        <page-fix-form-info-view [monType]="testingViewType" [monOrder]="2">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/design/marquee-test.png"
                     [attr.alt]="'Marquee testing sample image' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>Potential problems that can arise</h2>
                <p translate>
                    The chances that a marquee tag even exists in your website are quite low, as it is a tag that is no
                    longer relevant.
                    However, when you notice some styling changes that you do not like on your website where there used
                    to be some marquee tags, try changing them to a different tag (in options). Be aware that when
                    changing into a new tag it will also copy its styling.
                </p>
            </txt-slot>
        </page-fix-form-info-view>
    </page-fix-form-wizard-container>
</form>
